import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=50a14ab8&"
import script from "./Accordion.vue?vue&type=script&lang=ts&"
export * from "./Accordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports